import { render, staticRenderFns } from "./ModalProduto.vue?vue&type=template&id=535aab09"
import script from "./ModalProduto.vue?vue&type=script&lang=js"
export * from "./ModalProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports